import useExcelUrl from "app/useExcelUrl";
import { DataGridV2 as DataGrid, GridColumns } from "common";
import { getHistoryService, HistoryItem } from "features/histories/historyApi";
import HistoryForm from "features/histories/HistoryForm";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { useParams } from "react-router-dom";

export default function UserActivityList() {
  const { user_id } = useParams<"user_id">();
  const service = getHistoryService({ users: user_id });
  const { hasPermissions } = useAccess();
  const excelUrl = useExcelUrl(
    "histories",
    { users: user_id },
    { user_id },
    false,
  );
  const columns: GridColumns<HistoryItem> = [
    {
      field: "class_name",
      headerName: I18n.t("History.attributes.class_name"),
      flex: 1,
      renderCell: params => {
        return I18n.t(`${params?.row?.class_name}.title`, {
          defaultValue: params?.row?.class_name,
        });
      },
    },
    {
      field: "item_label",
      headerName: I18n.t("History.attributes.item_label"),
    },
    {
      field: "item_id",
      headerName: I18n.t("History.attributes.item_id"),
      type: "number",
    },
    {
      field: "event",
      headerName: I18n.t("History.attributes.event"),
      renderCell: params => {
        return I18n.t(`History.events.${params?.row?.event}`);
      },
    },
    {
      field: "created_at",
      headerName: I18n.t("History.attributes.created_at"),
      type: "datetime",
    },
  ];

  return (
    <DataGrid
      {...service}
      columns={columns}
      id="user-histories"
      renderModalForm={props => <HistoryForm {...props} />}
      defaultState={{ sorting: [{ field: "created_at", direction: "desc" }] }}
      canCreate={false}
      excelUrl={excelUrl}
      canDelete={hasPermissions(["history.editany", "history.editown"])}
      canEdit={hasPermissions(["history.editany", "history.editown"])}
      canHandleTrash={hasPermissions(["history.editany", "history.editown"])}
    />
  );
}
